class TabbedSlider extends HTMLElement {
  connectedCallback() {
    this.description = this.querySelector(
      `.${this.sectionClass}__body--description`
    )
    this.cta = this.querySelector(`.${this.sectionClass}__body--cta`)
    this.initSlider()
    this.initThumb()
  }

  get mainSliderSelector() {
    return this.getAttribute('slider-selector')
  }

  get thumbsSliderSelector() {
    return this.getAttribute('thumbs-selector')
  }

  get sectionClass() {
    return this.getAttribute('section-class')
  }

  initSlider() {
    const swiperEl = this.querySelector(
      `swiper-container${this.mainSliderSelector}`
    )

    const swiperParams = {
      direction: 'horizontal',
      autoHeight: true,
      centeredSlides: true,
      slidesPerView: 1.15,
      spaceBetween: 15,
      on: {
        slideChange: (swiper) => {
          const activeSlide = swiper.slides[swiper.activeIndex]
          this.style.setProperty(
            '--slide-text-color',
            activeSlide.dataset.textColor
          )
          this.style.setProperty(
            '--slide-cta-background-color',
            activeSlide.dataset.ctaBackgroundColor
          )
          this.style.setProperty(
            '--slide-background-color',
            activeSlide.dataset.backgroundColor
          )

          if (this.description) {
            this.description.textContent = activeSlide.dataset.description
          }

          if (this.cta) {
            this.cta.href = activeSlide.dataset.ctaLink
            this.cta.textContent = activeSlide.dataset.ctaTitle
          }
        },
      },
      breakpoints: {
        990: {
          slidesPerView: 1,
          direction: 'vertical',
        },
      },
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
  }

  initThumb() {
    const swiperEl = this.querySelector(
      `swiper-container${this.thumbsSliderSelector}`
    )

    const swiperParams = {
      spaceBetween: 16,
      watchSlidesProgress: true,
      autoHeight: true,
      slideToClickedSlide: true,
      slidesPerView: 'auto',
      centerInsufficientSlides: true,
      multipleActiveThumbs: false,
    }

    Object.assign(swiperEl, swiperParams)
    swiperEl.initialize()
  }
}

window.customElements.define('tabbed-slider', TabbedSlider)
